// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reputation-row[data-v-1d993bbe]{display:flex;gap:12px;margin-bottom:4px}.reputation-col[data-v-1d993bbe]{flex:1;min-width:0}.validation-error[data-v-1d993bbe]{color:#d93025;display:block;font-size:12px}.btn-next[data-v-1d993bbe]{display:block;height:36px;margin:12px 0 0;width:100%}", ""]);
// Exports
module.exports = exports;
